// eslint-disable-next-line import/no-unresolved
import { AuthVuexModule } from '@onereach/auth-ui-module/dist/vue2/index'
import authService from '../../api/auth'
import config from '@/config'

const authModule = AuthVuexModule(authService)

export default {
  ...authModule,

  actions: {
    ...authModule.actions,

    async checkAuthentication ({ commit, state, dispatch }, { initialPath = window.location.path, token }) {
      if (!state.authorized) {
        if (token) {
          token = decodeURIComponent(token)
        }

        await dispatch('init', {
          initialPath,
          token
        })

        if (!state.authorized) {
          throw new Error('Not authorized')
        }
      }
    },

    redirectToAuthPage (_, { currentPath = window.location.href } = {}) {
      console.log('redirectToAuthPage')
      const encodedRedirectPath = encodeURIComponent(currentPath)
      window.location = `${config.AUTH_UI_URL}/login?redirectPath=${encodedRedirectPath}`
    }
  }
}
